// Từ điển nhãn thẻ của màn Khiếu nại.
//
// Tách khỏi component vì bài hướng dẫn gọi tên thẻ theo đúng chữ trên màn; gõ
// chuỗi ở hai nơi thì đổi một nơi là bài chỉ tới thẻ không còn tồn tại, im
// lặng. Khoá chính là `value` của `TabsTrigger`, nên hộp hướng dẫn mở thẳng
// được vào thẻ người đọc đang đứng.
//
// Thứ tự khai = thứ tự trên màn = thứ tự vòng đời: lời khách vào sổ trước, vụ
// nào cần đền bù mới thành phiếu.

export const COMPLAINTS_TAB_LABEL = {
  voice: "Tiếng khách",
  tickets: "Phiếu khiếu nại",
} as const;

export type ComplaintsTabKey = keyof typeof COMPLAINTS_TAB_LABEL;
